import React, { Component } from 'react';
import { BrowserRouter as Router, Route, Switch, withRouter, Redirect } from 'react-router-dom';
import { AuthRoutes, QrRoutes } from 'auth/routes';
import { SecuredRoutes } from 'secured/routes';
import AceptAssetView from '../modules/employeeAssetAcept';

class Routes extends Component {
  componentDidCatch(error, info) {
    console.error(error, info);
  }

  render = () => {
    const next =
      window.location.search.indexOf('?p=') > -1 ? window.location.search.split('?p=').pop() : null;

    return next ? (
      <Redirect to={next} />
    ) : (
      <Switch>
        <Route path="/auth" component={withRouter(AuthRoutes)} />
        <Route path="/QR/:qrcode" component={QrRoutes} />
        <Route path="/asignAssetToEmployee/:token" component={AceptAssetView} />
        <Route path="/" component={withRouter(SecuredRoutes)} />
      </Switch>
    );
  };
}

export default () => (
  <Router>
    <Routes />
  </Router>
);



// WEBPACK FOOTER //
// src/routes/Routes.js